// React
import React from 'react';

// Components
import { MainCard } from 'components';

// Packages
import { Grid, Stack, Box, Button } from '@mui/material';

const RegistrationComplete = ({ registrationOrgName, resetForm }) => {
    return (
        <Grid
            item
            sm={8}
            sx={{
                backgroundColor: 'rgba(33, 35, 34, 0.05)',
                height: '100vh',
                padding: '40px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <MainCard
                style={{ padding: '10px 30px', fontSize: '1rem', lineHeight: '1.6' }}
                className={'oeThanks'}
            >
                <Box>
                    <Stack
                        spacing={4}
                        sx={{
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        <h2>Thank You for Enrolling!</h2>
                        <p>
                            Your enrollment for{' '}
                            <span className="oeSpan">{registrationOrgName}</span> has been
                            successfully completed. We’re thrilled to welcome you to the
                            SAGE community.
                        </p>
                        <div className="oeSteps">
                            <Stack
                                direction="row"
                                spacing={3}
                                sx={{ marginBottom: '30px' }}
                            >
                                <div className="oeNumberBox">
                                    <span>1</span>
                                </div>
                                <div className="text">
                                    <span className="oeSpan">Verification:</span> Your
                                    community management team will verify your
                                    information.
                                </div>
                            </Stack>
                            <Stack
                                direction="row"
                                spacing={3}
                                sx={{ marginBottom: '30px' }}
                            >
                                <div className="oeNumberBox">
                                    <span>2</span>
                                </div>
                                <div className="text">
                                    <span className="oeSpan">Invite:</span> Once verified,
                                    you’ll receive a text to activate your account.
                                </div>
                            </Stack>
                            <Stack
                                direction="row"
                                spacing={3}
                                sx={{ marginBottom: '30px' }}
                            >
                                <div className="oeNumberBox">
                                    <span>3</span>
                                </div>
                                <div className="text">
                                    <span className="oeSpan">Get Started:</span> Use the
                                    SAGE app to access all your community benefits!
                                </div>
                            </Stack>
                        </div>
                    </Stack>
                </Box>
                <Stack>
                    <Button
                        variant="contained"
                        className="oeOccupant"
                        size="large"
                        onClick={() => {
                            resetForm('hard');
                        }}
                    >
                        New Registration
                    </Button>
                </Stack>
            </MainCard>
        </Grid>
    );
};

export default RegistrationComplete;
